<template>
  <div class="opds-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>OPDS</span>
      </div>
      <div class="right-part">
        <button
          v-if="$route.query.categoryId"
          class="global-button-style"
          @click="
            $router.push({
              name: 'createOPDS',
              query: {
                ...$route.query,
              },
            })
          "
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <div class="boox-faq-main">
      <el-card class="boox-faq-main-left" :body-style="{ padding: '0px' }">
        <div slot="header">
          <span>目录</span>
        </div>
        <div class="opds-list-menu">
          <div style="flex: 1" v-bar>
            <div>
              <Draggable
                v-model="opdsCategory"
                @change="changeCategory"
                :animation="150"
              >
                <div
                  v-for="item in opdsCategory"
                  :key="item._id"
                  class="opds-list-menu-item"
                  :class="{ menuActive: item._id === $route.query.categoryId }"
                  @click="getCategoryDetails(item)"
                >
                  <p class="omitText" :title="item.title">{{ item.title }}</p>
                  <div class="opds-list-btn">
                    <div class="opds-list-handleBtn">
                      <i
                        class="el-icon-edit"
                        @click.stop="showCategoryHandle('edit', item)"
                      ></i>
                      <i
                        class="el-icon-close"
                        @click.stop="delOpdsCategory(item)"
                      ></i>
                    </div>
                    <el-switch
                      v-model="item.public"
                      :active-value="1"
                      :inactive-value="0"
                      @change="updatePublic(item)"
                    />
                  </div>
                </div>
              </Draggable>
            </div>
          </div>
          <button
            class="global-button-style"
            style="margin: 0"
            @click="showCategoryHandle('create')"
          >
            <i class="el-icon-plus"></i>
          </button>
        </div>
      </el-card>

      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <div class="global-body-wrap">
          <TableView
            :tableProp="tableProp"
            :tableData="tableData"
            :handleBtn="handleBtn"
            :currentPage="params.page"
            :pageSize="params.limit"
            @tableHandle="tableHandle"
          />
          <Pagination
            :pageSize="params.limit"
            :total="total"
            @pageNum="pageNum"
          />
        </div>
      </el-card>
    </div>

    <el-dialog
      :visible.sync="categoryVisible"
      width="30%"
      :title="categoryHandle === 'create' ? '新建' : '编辑'"
    >
      <div>
        <el-form
          :model="ruleForm"
          ref="formData"
          @submit.native.prevent
          label-position="top"
        >
          <el-form-item label="封面" prop="cover">
            <div class="opds-category-cover-main">
              <input
                v-show="false"
                ref="coverUploader"
                type="file"
                accept="image/*"
                @change="coverSelect"
              />
              <div class="opds-category-cover-warp">
                <template v-if="ruleForm.cover">
                  <el-image
                    class="opds-category-cover-imgs"
                    :src="ruleForm.cover"
                    fit="fill"
                    :lazy="true"
                    :preview-src-list="[ruleForm.cover]"
                  ></el-image>
                  <div class="opds-category-cover-btn">
                    <i
                      class="el-icon-delete"
                      @click.stop="ruleForm.cover = ''"
                    ></i>
                  </div>
                </template>
              </div>
              <div
                class="opds-category-upload-btn"
                @click="$refs.coverUploader.click()"
              >
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="名称" prop="title">
            <el-input
              v-model="ruleForm.title"
              @keydown.enter.exact.prevent.stop.native="
                categoryConfirm('formData')
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              type="textarea"
              resize="none"
              v-model="ruleForm.description"
              @keydown.enter.exact.prevent.stop.native="
                categoryConfirm('formData')
              "
              @keyup.shift.enter.prevent.exact.stop.native
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="categoryVisible = false">取消</el-button>
        <el-button type="primary" @click="categoryConfirm('formData')"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableView from "@/components/tableView";
import Pagination from "@/components/pagination";
import { mapGetters } from "vuex";
import OSS from "ali-oss";

import Draggable from "vuedraggable";

export default {
  components: {
    TableView,
    Draggable,
    Pagination,
  },
  computed: {
    ...mapGetters(["buckets"]),
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: "名称",
          placeholder: "请输入名称",
        },
      ];
      return ruleProps;
    },
    tableProp() {
      let tableProp = [
        {
          prop: "title",
          label: "标题",
        },
        {
          prop: "url",
          label: "OPDS地址",
        },
        {
          prop: "public",
          label: "发布状态",
        },
        {
          prop: "updatedAt",
          label: "更新日期",
        },
      ];
      return tableProp;
    },
    handleBtn() {
      return [
        { style: "checkDetailsBtn", type: "edit", title: "编辑" },
        { style: "delBtn", type: "del", title: "删除" },
      ];
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: {
        limit: 20,
        page: 1,
        sortBy: "createdAt",
        orderBy: "DESC",
        fileType: 1,
        sourceType: 2,
      },
      booxItem: null,
      updateId: "",
      opdsCategoryParams: {
        limit: 100000,
        page: 1,
        sortBy: "createdAt",
        orderBy: "DESC",
        fileType: 0,
        publicFeed: 1,
        sourceType: 2,
      },
      opdsCategory: [],
      ruleForm: {
        cover: "",
        title: "",
        description: "",
        fileType: 0,
        publicFeed: 1,
        public: 1,
        sourceType: 2,
      },
      currentItem: null,
      ossClient: null,
      categoryHandle: "create",
      categoryVisible: false,
    };
  },

  methods: {
    async changeCategory({ moved }) {
      let { newIndex, oldIndex, element } = moved;
      let ordinal;
      if (newIndex === 0) {
        // 拖到第一位置
        let timeStamp = new Date().getTime();
        ordinal = timeStamp;
      } else if (newIndex === this.opdsCategory.length - 1) {
        // 拖到最后位置
        let oldLastItem = this.opdsCategory[newIndex - 1];
        ordinal = oldLastItem.ordinal;
        if (this.opdsCategory.length === 2) {
          let timeStamp = new Date().getTime();
          oldLastItem.ordinal = timeStamp;
        } else {
          oldLastItem.ordinal =
            (ordinal + this.opdsCategory[newIndex - 2].ordinal) / 2;
        }
        let params = {
          ordinal: oldLastItem.ordinal,
        };
        await this.$http.updateRssList(oldLastItem._id, params);
      } else {
        ordinal =
          (this.opdsCategory[newIndex + 1].ordinal +
            this.opdsCategory[newIndex - 1].ordinal) /
          2;
      }
      let params = {
        ordinal,
      };
      await this.$http.updateRssList(element._id, params);
    },

    async getRssCategory() {
      let res = await this.$http.getRssList(this.opdsCategoryParams);
      this.opdsCategory = res.data.results;
      if (!this.opdsCategory.length) {
        this.$router.push({ name: "opds" });
        return;
      }

      let categoryId = this.$route.query.categoryId
        ? this.$route.query.categoryId
        : this.opdsCategory[0]._id;
      let categoryName = this.$route.query.categoryName
        ? this.$route.query.categoryName
        : this.opdsCategory[0].title;

      this.params.parent = categoryId;

      if (!this.$route.query.categoryId) {
        this.$router.push({
          name: "opds",
          query: {
            categoryId,
            categoryName,
          },
        });
      }
      this.getList();
    },

    async getCategoryDetails(item) {
      this.$router.push({
        name: "opds",
        query: {
          categoryId: item._id,
          categoryName: item.title,
        },
      });
      this.params.parent = item._id;
      this.params.page = 1;
      this.getList();
    },

    showCategoryHandle(type, item = null) {
      this.categoryHandle = type;
      if (this.categoryHandle === "create") {
        this.ruleForm = {
          cover: "",
          title: "",
          description: "",
          fileType: 0,
          publicFeed: 1,
          public: 1,
          sourceType: 2,
        };
      } else {
        this.ruleForm = Object.assign({}, item);
      }
      this.categoryVisible = true;
    },

    // 上传目录封面
    async coverSelect(el) {
      let file = el.target.files[0];
      this.ossClient = await this.getOssClient();
      this.ruleForm.cover = await this.uploadFiles(file);
      this.$refs.coverUploader.value = "";
    },

    getOssClient() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await await this.$http.aliyunSts();
          let { region, bucket } = this.buckets["onyx-static"];
          let creds = res.data;
          let client = new OSS({
            region,
            accessKeyId: creds.AccessKeyId,
            accessKeySecret: creds.AccessKeySecret,
            stsToken: creds.SecurityToken,
            bucket,
          });
          return resolve(client);
        } catch (error) {
          reject(error);
        }
      });
    },

    async uploadFiles(file) {
      return new Promise(async (resolve, reject) => {
        try {
          let format = file.name.split(".").pop();
          let key = `rss/cover/${this.random_string()}.${format}`;

          this.progress = 0;
          let imgData = await this.ossClient.multipartUpload(key, file, {
            progress: (p) => {
              // progress is generator
              this.progress = parseInt(p.toFixed(2) * 100);
            },
          });
          let url = imgData.res.requestUrls[0].split("?")[0];
          resolve(url);
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },

    async updatePublic(item) {
      await this.$http.updateRssList(item._id, item);
      this.elMsg(this.$t("alertMsg.editSuccess"), "success");
      this.getRssCategory();
    },

    categoryConfirm() {
      this.categoryHandle === "create"
        ? this.createRssList()
        : this.updateRssCategory();
    },

    async createRssList() {
      await this.$http.createRssList(this.ruleForm);
      this.getRssCategory();
      this.categoryVisible = false;
    },

    async updateRssCategory() {
      try {
        await this.$http.updateRssList(this.ruleForm._id, this.ruleForm);
        if (this.$route.query.categoryId === this.ruleForm._id) {
          this.$router.push({
            name: "opds",
            query: {
              categoryId: this.ruleForm._id,
              categoryName: this.ruleForm.title,
            },
          });
        }
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        this.getRssCategory();
        this.categoryVisible = false;
      } catch (error) {}
    },

    async delOpdsCategory(item) {
      try {
        await this.$confirm(null, this.$t("alertMsg.delConfirm"), {
          confirmButtonText: this.$t("commonMsg.confirm"),
          cancelButtonText: this.$t("commonMsg.cancel"),
          showClose: false,
          center: true,
        });
        await this.$http.delRssList(item._id);
        if (this.$route.query.categoryId === item._id) {
          this.$router.push({
            name: "opds",
            query: {
              categoryId: this.opdsCategory[0]._id,
              categoryName: this.opdsCategory[0].title,
            },
          });
        }
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        this.getRssCategory();
      } catch (error) {}
    },

    // 表格操作按钮
    tableHandle(obj) {
      let { type, data } = obj;
      this.currentItem = data;
      if (type === "del") {
        this.deleteHandle();
      } else if (type === "edit") {
        this.toEdit();
      }
    },
    //  确认删除
    async deleteHandle() {
      try {
        await this.$confirm(null, this.$t("alertMsg.delConfirm"), {
          confirmButtonText: this.$t("commonMsg.confirm"),
          cancelButtonText: this.$t("commonMsg.cancel"),
          showClose: false,
          center: true,
        });
        await this.$http.delRssList(this.currentItem._id);
        this.getList();
      } catch (error) {}
    },

    async getList() {
      let res = await this.$http.getRssList(this.params);
      this.tableData = res.data.results;
      this.total = res.data.count;
    },
    toEdit() {
      this.$router.push({
        name: "createOPDS",
        query: { id: this.currentItem._id, ...this.$route.query },
      });
    },

    // toPublic(data) {
    //   this.$http.publicFaq({ id: data.id, data: data }).then(res => {
    //     this.getList();
    //     this.elMsg(this.$t("alertMsg.publicSuccess"), "success");
    //   });
    // },
    // toView(id) {
    //   this.$router.push({ name: "faqView", query: { id: id } });
    // },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    },
  },
  watch: {},
  mounted() {
    this.getRssCategory();
  },
};
</script>

<style lang="scss">
.opds-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .boox-faq-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .boox-faq-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .opds-list-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .opds-list-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          &:hover {
            background: #f3f6f9;
            > .opds-list-btn {
              > .opds-list-handleBtn {
                display: block;
              }
            }
          }
          > p {
            margin-right: 10px;
          }
          .opds-list-btn {
            display: flex;
            align-items: center;
            > .opds-list-handleBtn {
              min-width: 50px;
              display: none;
              > i + i {
                margin-left: 10px;
              }
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .boox-dialog-item {
    padding-bottom: 10px;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .green {
    color: #28c328;
  }
}

.opds-category-cover-main {
  display: flex;
  .opds-category-cover-warp {
    position: relative;
    &:hover {
      .opds-category-cover-btn {
        display: flex;
      }
    }
    .opds-category-cover-imgs {
      margin-right: 10px;
      width: 80px;
      height: 80px;
      border-radius: 4px;
    }
    .opds-category-cover-btn {
      width: 80px;
      display: none;
      justify-content: space-around;
      align-items: center;
      position: absolute;
      bottom: 11px;
      left: 0;
      box-sizing: border-box;
      padding: 6px;
      background: rgba($color: $globalBGColor, $alpha: 1);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      > i {
        color: #fff;
        cursor: pointer;
      }
    }
  }
}

.opds-category-upload-btn {
  width: 78px;
  height: 78px;
  border: 1px dashed #c0ccda;
  border-radius: 4px;

  background-color: #fbfdff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    border-color: $globalLessBGColor;
    > i {
      color: $globalBGColor;
    }
  }
  > i {
    font-size: 20px;
    color: #8c939d;
  }
}
</style>
